<template>
  <div class="pg-input-range" :style="{ 'justify-content': readonly ? 'center' : 'flex-start' }">
    <template v-if="!readonly">
      <PgInput v-bind="$attrs" :value="start" @change="(v) => change(v, 'start')" />
      <span class="separater">{{ separater }}</span>
      <PgInput v-bind="$attrs" :value="end" @change="(v) => change(v, 'end')" />
    </template>
    <template v-else>
      <span>{{ start || '-' }}</span>
      <span class="separater">{{ separater }}</span>
      <span>{{ end || '-' }}</span>
    </template>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { ref } from 'vue'
import { PgInput } from '../../input'
import { useInputRange } from '../hooks/index'

const emit = defineEmits(['input'])

const props = defineProps({
  value: {
    type: Array,
    default() {
      return []
    },
  },
  separater: {
    type: String,
    default: '~',
  },
  readonly: { type: Boolean, default: false },
})

const start = ref(props.value?.[0])
const end = ref(props.value?.[1])

const { change } = useInputRange({ start, end, props, emit })
</script>
<style lang="scss">
@import '../style/input-range.scss';
</style>
